import { render, staticRenderFns } from "./resultInfo.vue?vue&type=template&id=6879023f&scoped=true&"
import script from "./resultInfo.vue?vue&type=script&lang=js&"
export * from "./resultInfo.vue?vue&type=script&lang=js&"
import style0 from "./resultInfo.vue?vue&type=style&index=0&id=6879023f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6879023f",
  null
  
)

export default component.exports